import { useNavigate } from 'react-router-dom';
import './index.scss';
const NavBar = ({ title, onGoBack }) => {
  const navigate = useNavigate();




  return (
    <div className="common-nav-bar">

      <i
        className="iconfont icon-zuo"
        onClick={() => {
          navigate(-1)
        }}
        role="button"
        tabIndex={0}
        aria-label="返回上一页"
      />

      <h2>{title}</h2>
    </div>
  );
};

export default NavBar;
